module.exports = __webpack_public_path__ + "static/media/p_21_1.bb9885d5.png";